import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("titan_lang") || "en");

  useEffect(() => { localStorage.setItem("titan_lang", lang); document.documentElement.lang = lang; }, [lang]);

  const t = useCallback((path) => {
    const parts = path.split(".");
    let node = translations[lang] || translations.en;
    for (const p of parts) { if (node && p in node) node = node[p]; else return path; }
    return node;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>
  );
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
};
